import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  VerifyCacheResponse,
  ErrSuccess,
  LoanConfigInitResponse,
  LoanConfigResponse,
} from '../../../types'

import { initialState } from './model'

export const product = createSlice({
  name: 'product',
  initialState,
  reducers: {
    commitLoanConfiguratorRe: (_state, _action: PayloadAction<ErrSuccess>) => {},
    initLoanConfigurator: (_state, _action: PayloadAction<ErrSuccess>) => {},
    updateLoanConfigurator: (_state, _action: PayloadAction<ErrSuccess>) => {},
    saveLoanPreConfigurator: (_state, _action: PayloadAction<ErrSuccess>) => {},
    setInitialData: (state, { payload }: PayloadAction<LoanConfigInitResponse>) => {
      state.canFinishInIB = payload.canFinishInIB
      state.canFinishOnline = payload.canFinishOnline
      state.configuration = payload.configuration
      state.insuranceRequested = payload.insuranceRequested
      state.scoringResultCalculation = payload.scoringResultCalculation
    },
    setUpdatedData: (state, { payload }: PayloadAction<LoanConfigResponse>) => {
      state.configuration = payload.configuration
    },
    setDataFromCache: (state, { payload }: PayloadAction<VerifyCacheResponse>) => {
      const { express } = payload.productParameters

      state.configuration.loanAmount = express.loanAmount
      state.configuration.rpsn = express.rpsn
      state.configuration.term = express.term
      state.instalmentDay = express.instalmentDay
    },
    setDataPreConfigurator: (
      state,
      {
        payload,
      }: PayloadAction<{ instalmentDay: number; loanAmount: number; rpsn: number; term: number }>
    ) => {
      state.configuration.loanAmount = payload.loanAmount
      state.configuration.rpsn = payload.rpsn
      state.configuration.term = payload.term
      state.instalmentDay = payload.instalmentDay
    },
  },
})

export const productActions = product.actions

export default product.reducer
